module.exports = __webpack_public_path__ + "static/media/staff-profile-sider.d7356c7b.png";